import App from 'app/App';
import Provider from 'app/Provider';
import React from 'react';
import {createRoot} from 'react-dom/client';

// eslint-disable-next-line
const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider>
      <App />
    </Provider>
  </React.StrictMode>,
);
